
import CardServices from '../cardServices';
import { useEffect, useState } from "react";
import api from '../../../services/api';
import { useSelector } from 'react-redux';
import { temPermissao } from '../../../utils/permissoes';

type MenuProps = {
  nomeArea: string
  nomeService: string
  permissao: string
}

interface RootState {
  account: {
    user: {
      tipo: string;
      membro: string;
      title?: string;
      funcao?: string;
      permissions: string[];
    }
  };
}

export default function ServicoReclamacoesAreas({ nomeArea, nomeService, permissao }: MenuProps) {
  const [loadMenu, setLoadMenu] = useState<boolean>(true)
  const [areaCount, setAreaCount] = useState([])
  const user = useSelector((state: RootState) => state.account.user); 


  useEffect(() => {
    api.get(`/reclamacoes?departamento=${nomeArea}&status=encaminhado`) 
      .then(response => {
        setAreaCount(response.data?.totalItems);
      }).catch(() => {
      }).finally(() => setLoadMenu(false))
  }, [nomeArea])

  return (
  <CardServices disabled={!temPermissao(user, [permissao])}  load={loadMenu} count={Number(areaCount)} icone={'/icones/Reclamacoes.svg'} nomeService={nomeService} link={`/admin/reclamacoes?page=1&departamento=${nomeArea}`} />) 
}
